import { render, staticRenderFns } from "./FormLayoutHorizontal.vue?vue&type=template&id=80205526&"
import script from "./FormLayoutHorizontal.vue?vue&type=script&lang=js&"
export * from "./FormLayoutHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports